<template>
  <div class="row">
    <div v-if="user" class="col-12">
      <Heading>
        {{ user.name || user.username }}
      </Heading>
      <div class="border border-light p-5">

        <div class="row">

          <div class="col-4">
            <b class="text-primary">username:</b><br>
            {{ user.username }}

          </div>
          <div class="col-4">
            <b class="text-primary">Rolle:</b><br>
            {{ user.role || "-" }}
          </div>
          <div class="col-4">
            <b class="text-primary">Status:</b><br>
            <template v-if="user.active">
              <span>Aktiv</span>
            </template>
            <template v-else>
              <span class="text-danger">Inaktiv</span>
            </template>
          </div>
          <div class="col-3 offset-9 text-right">
            <button @click="edit" class="btn btn-primary btn-block mt-5 btn-sm">Bearbeiten<i
                class="fas fa-pencil-alt pl-4"></i></button>
          </div>
        </div>
      </div>
      <list v-if="user.bottles > 0" :items="user.bottles" class="mt-5">
        <template v-slot:header>
          <div class="row">
            <div class="col-4">Flaschen Nummer</div>
            <div class="col-4">Typ</div>
            <div class="col-3">Fällig am</div>
          </div>
        </template>
        <template v-slot:itemTemplate="{item}">
          <div class="row align-items-center py-1">
            <!--						 <div class="col-12">{{item}}</div>-->
            <div class="col-4">
              Nr. {{ item.serial }}
            </div>
            <div class="col-4">
              {{ item.type }}
            </div>
            <div class="col-3">
              {{ dateWithFormat(item.due) }}
            </div>
            <div class="col-1">
              <button class="btn" @click="$router.push('/admin/bottles/'+item.id)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </template>
      </list>
    </div>
  </div>
</template>

<script>
import Heading from "../../components/admin/Heading";
import {mapActions, mapState} from "vuex";
import BottleState from "../../components/admin/BottleState";
import List from "../../components/admin/List";
import timeFormatter from "../../mixins/timeFormatter";
import DataSelect from "../../components/DataSelect";

export default {
  name: "UserDetail",
  components: {DataSelect, Heading, BottleState, List},
  mixins: [timeFormatter],
  computed: {
    ...mapState({
      user: state => state.Api.Users.current
    })
  },
  mounted() {
    this.fetchUserDetails({id: this.$route.params.user_id})
        .catch(this.apiErrorHandler)
  },
  methods: {
    ...mapActions({
      fetchUserDetails: "Api/Users/get"
    }),
    edit() {
      this.$router.push(['', 'admin', 'users', this.$route.params.user_id, 'edit'].join(('/'))).catch(() => null);
    }
  }
}
</script>

<style scoped>

</style>
